import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UnderlineElement from '../common/UnderlineElement';
import { checkParent, cleanSearchParent } from '../../actions/parentActions';
import Input from '../common/Input';

class ParentSearch extends Component {
  constructor(props) {
    super(props);

    this.state = { active: false, ci: '' };

    this.onSearch = this.onSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentWillReceiveProps(nextState) {
    const { parent } = nextState;
    if (!parent.isEmpty()) {
      const { fields, cleanSearchParent } = this.props;
      fields.push(parent);
      cleanSearchParent();
    }
  }

  onSearch() {
    const { checkParent } = this.props;
    const { ci } = this.state;
    checkParent(ci);
  }

  onChange(e) {
    const { value } = e.target;
    this.setState({ ci: value });
  }

  onKeyPress(e) {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  }

  render() {
    const { error } = this.props;
    const { active, ci } = this.state;
    const { onChange, onSearch, onKeyPress } = this;
    const input = { value: ci, onChange, onKeyPress };
    const meta = { touched: false };

    if (!active) {
      return (
        <div onClick={() => this.setState({ active: true })}>
          <UnderlineElement>
            ¿Buscar padre?
          </UnderlineElement>
        </div>
      );
    }

    return (
      <div className="searcher">
        <Input
          type="text"
          placeholder="Buscar padre por CI"
          input={input}
          meta={meta}
        />
        <button
          type="button"
          className="default-button"
          onClick={onSearch}
        >
          Buscar
        </button>
        { error &&
          <p className="error-message">
            No se encontraron resultados
          </p>
        }
      </div>
    );
  }
}

const { object, bool, func } = PropTypes;

ParentSearch.propTypes = {
  checkParent: func.isRequired,
  cleanSearchParent: func.isRequired,
  fields: object.isRequired,
  error: bool.isRequired
};

const mapState = state => ({
  parent: state.getIn(['parent', 'checkedParent']),
  error: state.getIn(['parent', 'checkedError'])
});

const mapDispatch = dispatch => ({
  checkParent: ci => dispatch(checkParent(ci)),
  cleanSearchParent: () => dispatch(cleanSearchParent())
});

export default connect(mapState, mapDispatch)(ParentSearch);



// WEBPACK FOOTER //
// ./src/components/parent/ParentSearch.js